import { Box, Typography } from "@mui/material";

export interface WhyElementProps {
  title: string;
  description: string;
  imageUrl: string;
  imgZoomLevel: number;
}

const WhyElement = ({
  title,
  description,
  imageUrl,
  imgZoomLevel,
}: WhyElementProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        rowGap: 1,
        marginBottom: { xs: "2.5rem", md: "0rem" },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Box>
          <img
            src={imageUrl}
            style={{
              width: "100px",
              height: "100px",
              transform: `scale(${imgZoomLevel})`,
            }}
          />
        </Box>
      </Box>
      <Box>
        <Typography variant="whyTitle" sx={{ fontStyle: "italic" }}>
          {title}
        </Typography>
      </Box>
      <Box>
        <Typography variant="whyText">{description}</Typography>
      </Box>
    </Box>
  );
};

export default WhyElement;
